
import React from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import toast from "react-hot-toast";

const Dineoutinvoice = ({ isOpen, onClose, orderData }) => {
  if (!isOpen || !orderData) return null;

  // ✅ SAFE ITEMS (ALL POSSIBLE KEYS HANDLED)
  const items =
    orderData.order ||
    orderData.items ||
    orderData.cartItems ||
    orderData.orderItems ||
    [];

  // ---------------- PDF DOWNLOAD ----------------
  const downloadPDF = async () => {
    const element = document.getElementById("invoice-popup-content");
    if (!element) return;

    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save(`invoice_${orderData.orderId || "bill"}.pdf`);

      toast.success("PDF downloaded successfully!");
    } catch (err) {
      console.error(err);
      toast.error("PDF download failed");
    }
  };

  // ---------------- PRINT ----------------
  const printInvoice = () => {
    const content = document.getElementById("invoice-popup-content");
    if (!content) return;

    const win = window.open("", "_blank");

    win.document.write(`
      <html>
        <head>
          <title>Invoice</title>
          <style>
            body { font-family: Arial; padding: 20px; }
          </style>
        </head>
        <body>
          ${content.innerHTML}
          <script>
            window.onload = () => window.print();
          <\/script>
        </body>
      </html>
    `);

    win.document.close();
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 20,
        zIndex: 9999,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          width: "90%",
          maxWidth: 550,
          maxHeight: "90vh",
          overflowY: "auto",
          borderRadius: 16,
          position: "relative",
        }}
      >
        {/* CLOSE */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            right: 10,
            top: 10,
            width: 34,
            height: 34,
            borderRadius: "50%",
            border: "none",
            background: "#ee6521",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          ✕
        </button>

        <div id="invoice-popup-content" style={{ padding: 20 }}>
          
          {/* HEADER */}
          <div
            style={{
              textAlign: "center",
              borderBottom: "2px solid #ee6521",
              paddingBottom: 15,
              marginBottom: 20,
            }}
          >
            <h2 style={{ margin: 0, color: "#ee6521" }}>
              {orderData.vendorRegisteredName || ""}
            </h2>

            <p style={{ fontSize: 11, color: "#666" }}>
              {orderData.vendorFullAddress || ""}
            </p>

            <p style={{ fontSize: 11, color: "#666" }}>
              {orderData.vendorPhone || ""}
            </p>

            <p style={{ fontSize: 10, color: "#999" }}>
              GST: {orderData.vendorGstIn || ""}
            </p>
          </div>

          {/* ORDER INFO */}
          <div style={{ fontSize: 12, background: "#f9f9f9", padding: 10 }}>
            <div>Order ID: {orderData.orderId || ""}</div>
            <div>Date: {orderData.date || ""} {orderData.time || ""}</div>
            <div>Customer: {orderData.userName || ""}</div>
            <div>Type: {orderData.orderTypes || orderData.orderType || ""}</div>
            <div>Table: {orderData.tableCode || ""}</div>
          </div>

          {/* ITEMS */}
          <table style={{ width: "100%", marginTop: 10, fontSize: 12 }}>
            <thead>
              <tr>
                <th align="left">Item</th>
                <th>Qty</th>
                <th align="right">Price</th>
                <th align="right">Total</th>
              </tr>
            </thead>

            <tbody>
              {items.map((item, i) => (
                <tr key={i}>
                  <td>
                    {item.productName || item.name || item.dishName || ""}
                  </td>
                  <td align="center">{item.quantity || 0}</td>
                  <td align="right">
                    ₹{Number(item.price || 0).toFixed(2)}
                  </td>
                  <td align="right">
                    ₹{(Number(item.price || 0) * Number(item.quantity || 0)).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* TOTALS */}
          <div style={{ marginTop: 15, borderTop: "1px solid #ddd", paddingTop: 10 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Subtotal:</span>
              <span>₹{Number(orderData.subTotal || 0).toFixed(2)}</span>
            </div>

            {/* CGST */}
            {(orderData.cgstRate || orderData.cgst || 0) > 0 && (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>CGST ({orderData.cgstRate || orderData.cgst}%):</span>
                <span>
                  ₹
                  {(
                    Number(orderData.subTotal || 0) *
                    Number(orderData.cgstRate || orderData.cgst || 0) /
                    100
                  ).toFixed(2)}
                </span>
              </div>
            )}

            {/* SGST */}
            {(orderData.sgstRate || orderData.sgst || 0) > 0 && (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>SGST ({orderData.sgstRate || orderData.sgst}%):</span>
                <span>
                  ₹
                  {(
                    Number(orderData.subTotal || 0) *
                    Number(orderData.sgstRate || orderData.sgst || 0) /
                    100
                  ).toFixed(2)}
                </span>
              </div>
            )}

            {/* FINAL TOTAL */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 10,
                fontWeight: "bold",
                borderTop: "1px solid #000",
                paddingTop: 8,
              }}
            >
              <span>TOTAL:</span>
              <span style={{ color: "#ee6521" }}>
                ₹{Number(orderData.totalAmount || 0).toFixed(2)}
              </span>
            </div>
          </div>

          {/* PAYMENT */}
          <div style={{ fontSize: 11, marginTop: 10 }}>
            <div>Payment: {orderData.paymentMethod || ""}</div>
            <div>Status: {orderData.status || ""}</div>
            <div>Txn ID: {orderData.transactionId || ""}</div>
          </div>

          {/* FOOTER */}
          <div style={{ textAlign: "center", marginTop: 15, fontSize: 10 }}>
            Thank You
          </div>
        </div>

        {/* ACTION BUTTONS */}
        <div style={{ display: "flex", gap: 10, padding: 15 }}>
          <button onClick={downloadPDF} style={{ flex: 1 }}>
            PDF
          </button>
          <button onClick={printInvoice} style={{ flex: 1 }}>
            Print
          </button>
          <button onClick={onClose} style={{ flex: 1 }}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dineoutinvoice;